import React, { useState, useEffect } from 'react';
import 'rc-pagination/assets/index.css';
import Pagination from 'rc-pagination';
import axios from 'axios';
import { Configurations } from '../../Utils/Configurations';
import { Modal, ModalHeader, ModalBody } from 'reactstrap';



const InsertPodcast = (props) => {

    const config = new Configurations();


    const [hasError, setHasError] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');

    useEffect(() => {
        if (!props.isOpen) {
            setPodcastPrograma(null);
            setPodcastEpisodio({ idEpisodio: null, nomeEpisodio: '', episodioSelecionado: null });
            setHasError(false)
        } else {
            carregaListaProgramas();
        }
    }, [props.isOpen]);




    const [{ idEpisodio, nomeEpisodio, episodioSelecionado }, setPodcastEpisodio] = useState({ idEpisodio: null, nomeEpisodio: '', episodioSelecionado: null }),
        selecionaEpisodio = (_episodio) => {
            setPodcastEpisodio({ idEpisodio: _episodio.idEpsodio, nomeEpisodio: _episodio.nome, episodioSelecionado: _episodio });
        }

    const nomePrograma = () => {
        const _programa = listaProgramas.filter(item => item.idPoadcast === idPodcastPrograma)[0];
        return _programa ? _programa.nome : '';
    }

    const { handleModalPodcast, toggle, isLoadingInserirPodcast, flagContent
    } = props;


    const
        onChangePage = (page) => {
            selecionaPodcastPrograma(idPodcastPrograma, page)

        }

    const [paginacaoEpisodiosPodcasts, setPaginacaoEpisodiosPodcasts] = useState({});
    const [isLoadingEpisodiosPodcasts, setIsLoadingEpisodiosPodcasts] = useState(false);
    const [listaEpisodiosPodcasts, setListaEpisodiosPodcasts] = useState([]);
    const episodiosPorPagina = 9;


    const [idPodcastPrograma, setPodcastPrograma] = useState(null);

    const selecionaPodcastPrograma = (idPodcastPrograma, pagina = 1) => {

        setIsLoadingEpisodiosPodcasts(true)
        setPodcastPrograma(idPodcastPrograma)
        axios.get(config.apiBasePath + `/podcasts/${idPodcastPrograma}/episodios?page=${pagina}&pageSize=${episodiosPorPagina}`)
            .then(response => {
                setPaginacaoEpisodiosPodcasts(response.data.paginacao)
                setListaEpisodiosPodcasts(response.data.data)
                setHasError(false)
            })
            .catch(handleError)
            .finally(() => {
                setIsLoadingEpisodiosPodcasts(false);
            });
    }


    const [isLoadingProgramas, setIsLoadingProgramas] = useState(true);
    const [listaProgramas, setListaProgramas] = useState([]);
    const carregaListaProgramas = () => {
        setIsLoadingProgramas(true)
        axios.get(config.apiBasePath + `/podcasts?pageSize=50`)
            .then(response => {
                setListaProgramas(response.data.podcastProgramas)
                setHasError(false)
            })
            .catch(handleError)
            .finally(() => setIsLoadingProgramas(false));
    }


    const handleError = (err) => {
        setHasError(true)
        setErrorMessage((err.response && !!err.response.data.message) ? err.response.data.message : 'Erro inesperado.')
    }


    return (
        <Modal size="lg" isOpen={props.isOpen} toggle={toggle} returnFocusAfterClose={false}>
            <ModalHeader toggle={toggle}>{flagContent ? "Incluir podcast" : "Inserir podcast"}</ModalHeader>
            <ModalBody>
                <div className="row no-gutters insert-video">
                    {idPodcastPrograma === null ? (
                        <div className="col-12">
                            <div className="row no-gutters">
                                <div className="col-12 text-center">
                                    <strong>Lista de Programas</strong>
                                </div>

                                <div className="col-12 px-3">
                                    {isLoadingProgramas ? (
                                        <div className="row">
                                            <div className="col-12 py-5 text-center">
                                                <div className="spinner-border text-primary" role="status" />
                                            </div>
                                        </div>
                                    ) : (
                                        <div className="row">
                                            {listaProgramas.length > 0 ? listaProgramas.map((prog, index) => {
                                                return (
                                                    <div onClick={() => selecionaPodcastPrograma(prog.idPoadcast)} key={`prog-${index}`} className="col-4 p-1 cursor-pointer">

                                                        <img className="img img-fluid img-programa" src={prog.imagem} alt={'capa-' + prog.nome} />
                                                    </div>
                                                )
                                            }) : (
                                                <React.Fragment>
                                                    {hasError ? (
                                                        <div className='col-12 text-center text-danger'>
                                                            <p>{errorMessage}</p>
                                                        </div>
                                                    ) : (
                                                        <div className="col-12 py-2 text-center">
                                                            <p className="m-0">Não há programas disponíveis.</p>
                                                        </div>
                                                    )}
                                                </React.Fragment>
                                            )}
                                        </div>
                                    )}

                                </div>
                            </div>
                        </div>
                    ) : (
                        <div className="col-12">
                            <div className="row no-gutters">
                                <div className="col-9 text-left px-2">
                                    <h3>Programa: "{listaProgramas.filter(item => item.idPoadcast === idPodcastPrograma)[0].nome}"</h3>
                                </div>
                                <div className='col-3 text-right px-2'>
                                    <button className='btn btn-outline-secondary' onClick={() => setPodcastPrograma(null)}>voltar</button>
                                </div>
                                <div className="col-12 text-left px-2">
                                    <strong>Lista de Episódios</strong>
                                </div>

                                <div className="col-12 px-3">
                                    {isLoadingEpisodiosPodcasts ? (
                                        <div className="row">
                                            <div className="col-12 py-5 text-center">
                                                <div className="spinner-border text-primary" role="status" />
                                            </div>
                                        </div>
                                    ) : (
                                        <div className="row">
                                            {listaEpisodiosPodcasts.length > 0 ? listaEpisodiosPodcasts.map((episodio, index) => {
                                                return (
                                                    <div onClick={() => selecionaEpisodio(episodio)} key={`prog-${index}`} className={'col-4 p-2 cursor-pointer' + (episodio.idEpsodio === idEpisodio ? ' episodio-selecionado' : '')}>
                                                        <img className="img img-fluid img-episodio" src={episodio.imagem} alt={'capa-' + episodio.nome} />
                                                        <p><strong>{episodio.nome}</strong></p>
                                                    </div>
                                                )
                                            }) : (
                                                <React.Fragment>
                                                    {hasError ? (
                                                        <div className='col-12 text-center text-danger'>
                                                            <p>{errorMessage}</p>
                                                        </div>
                                                    ) : (
                                                        <div className="col-12 p-2 text-center">
                                                            <p className="m-0">Não há episódios disponíveis para esse programa.</p>
                                                        </div>
                                                    )}
                                                </React.Fragment>
                                            )}
                                        </div>
                                    )}
                                </div>
                                {isLoadingInserirPodcast ? (
                                    <div className="col-12 py-4 text-center">
                                        <div className="spinner-border text-primary" role="status" />
                                    </div>
                                ) : (
                                    <div className="col-12 py-4 text-center">
                                        <button disabled={!idEpisodio} onClick={() => handleModalPodcast({ idProg: idPodcastPrograma, idEpisodio, nomeEpisodio, tipo: 2, episodio: episodioSelecionado, nomePrograma: nomePrograma() })} className="btn btn-outline-success">{flagContent ? "Incluir podcast" : "Inserir podcast"}</button>
                                    </div>
                                )}
                            </div>
                        </div>
                    )}
                    {!!listaEpisodiosPodcasts && listaEpisodiosPodcasts.length > 0 && !!paginacaoEpisodiosPodcasts && (
                        <div className="col-12 mt-2 px-0">
                            <div className="paginacao-videos">
                                <Pagination onChange={onChangePage} current={paginacaoEpisodiosPodcasts.paginaAtual} total={(paginacaoEpisodiosPodcasts.totalPaginas * episodiosPorPagina)} pageSize={episodiosPorPagina} />
                            </div>
                        </div>
                    )}
                </div>
            </ModalBody>
        </Modal>
    );
}

export default InsertPodcast;